import React from 'react';
import { Link } from 'react-router-dom';
import MainMenu from './mainmenu';
import SearchIcon from './SearchIcon';
import SideBar from './SideBar';
import Dropdown from 'react-bootstrap/Dropdown';
import { useState, useEffect } from 'react';

export default function HeaderOne() {
	
	const openSideBar = () =>{
		document.body.classList.add('on-side');
		
	}

	useEffect(() => {
        window.addEventListener('scroll', isSticky);
        return () => {
            window.removeEventListener('scroll', isSticky);
        };
    });           
    /* Method that will fix header after a specific scrollable */
	const isSticky = (e) => {
		const header = document.querySelector('.main-header-area');
		const scrollTop = window.scrollY;
		scrollTop >= 250 ? header.classList.add('sticky-menu') : header.classList.remove('sticky-menu');
	};
		
  return (
    <>
	<div className="body-overlay activemode"></div>
	<SideBar/>
    <header className="header-top-area">
		<div className="container d-none d-sm-block">
			<div className="row header-top gx-0">
				<div className="col-xl-4 col-lg-3 d-none d-lg-inline-block">
					<div className="logo-area pl-30">
						<Link className="head-logo-1" to="/">
							<img src="assets/img/logo/header-logo-1.png" alt="Header-logo" />
						</Link>
					</div>
				</div>
				<div className="col-xl-8 col-lg-9">
					<ul className="right-query list-none d-sm-flex justify-content-center justify-content-lg-end">
						<li>
							<div className="icon"><i className="fas fa-phone"></i></div>
							<div className="query-list">
								<span>Phone Number</span>
								<p className="text-heding">890. 908. 645. 45</p>
							</div>
						</li>
						<li>
							<div className="icon"><i className="fas fa-envelope"></i></div>
							<div className="query-list">
								<span>Email Address</span>
								<p className="text-heding">info@webmail.com</p>
							</div>
						</li>
						<li>
							<Link className="theme_btn quote-btn" to="contact">Free Consultation</Link>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div className="main-header-area">
			<div className="container">
				<div className="border-tops white-bg row align-items-center gx-0">
					<div className="col-lg-10 col-6 text-start">
						<div className="logo-area d-lg-none d-md-block">
							<a to="index.html"><img src="assets/img/logo/header-logo-1.png" alt="Header-logo" /></a>
						</div>
						<div className="d-none d-lg-block">
							<MainMenu/>
						</div>
					</div>
					<div className="col-lg-2 col-6 text-end">
						<ul className="right-nav mb-0 d-flex align-items-center justify-content-end">
							<li>							
							<Dropdown>
									<Dropdown.Toggle variant="" id="dropdownMenuLink" className="language-btn">
										Language <i className="fal fa-chevron-down"></i>
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-menu" aria-labelledby="dropdownMenuLink">
										<Dropdown.Item href="#/action-1" className="dropdown-item">English</Dropdown.Item>
										<Dropdown.Item href="#/action-2" className="dropdown-item">Arbic</Dropdown.Item>
										<Dropdown.Item href="#/action-3" className="dropdown-item">Spanish</Dropdown.Item>
									</Dropdown.Menu>
								</Dropdown>
							</li>
							<li className="search-area d-none d-md-inline-block">							
								<SearchIcon/>									
							</li>
							<li>
								<div className="hamburger-menu">									
								<a  onClick={openSideBar}><img src="assets/img/icon/eclips-1.png" alt="Eclips" /></a>								
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>

	</header>
    </>
  )
}
